import styled from "@emotion/styled"

const Center = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;

  background: #F8F8F9;
`

export default Center;